import { ReactNode } from "react";
import { Text } from "@chakra-ui/react";

type Props = {
  children: ReactNode;
};

export default function InputErrorMessage({ children }: Props) {
  return (
    <Text
      as="span"
      display="flex"
      alignItems="center"
      fontSize="medium"
      textColor="red.500">
      {children}
    </Text>
  );
}
